import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import EditProductInformation from 'pages/edit-products/EditProductInformation';
import EditColorInformation from 'pages/edit-products/EditColorInformation';
import EditProductSizes from 'pages/edit-products/EditProductSizes';
import EditPrintProviderInformation from 'pages/edit-products/EditPrintProvider';
import EditProductDesignerSettings from 'pages/edit-products/EditProductDesignerSettings';
import EditDtgPlus from 'pages/edit-products/EditDtgPlus';
import EditProductArtwork from 'pages/edit-products/EditProductArtwork';
import EditProductAdditionalImages from 'pages/edit-products/EditProductAdditionalImages';
import EditPrintAreas from 'pages/edit-products/EditPrintAreas';
import EditProductSKU from 'pages/edit-products/EditProductSKU';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PhotoIcon from '@material-ui/icons/Photo';
import HeightIcon from '@material-ui/icons/Height';
import {
  Container,
  DialogTitle,
} from 'styles/pages/edit-products/editProductDialog';
import ColorLensIcon from '@material-ui/icons/ColorLens';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import SettingsIcon from '@material-ui/icons/Settings';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import StyleIcon from '@material-ui/icons/Style';
import AmpStoriesIcon from '@material-ui/icons/AmpStories';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};

const EditProductDialog = ({
  open,
  setModal,
  product,
  categories,
  styleTags,
  brandsTags,
  promosTags,
  updateProductInformation,
  updateProductSizes,
  editColorsInformation,
  editDesignerSettings,
  updateProductPrintProviders,
  deleteProduct,
  editDTGPlusInformation,
  editProductArtworkSettings,
  addAdditionalImages,
  editAdditionalTechniquesArtSettings,
  updatePrintArea,
  editSKUInformation,
}) => {
  const [tab, setTab] = useState(0);
  const handleTabChange = (event, newValue) => setTab(newValue);
  const isAu = product?.PrintProviders?.find((p) => p?.ProviderName === 'AU');
  const isEu = product?.PrintProviders?.find((p) => p?.ProviderName === 'EU');

  const handleClose = () => setModal(false);
  const productId = product?.Product?.ID;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" scroll="paper">
      <Container>
        <DialogTitle>
          {productId ? 'Edit Product' : 'Add Product'}
          {/* {productId && (
            <Tooltip title='This step cannot be undone'>
              <DeleteIcon
                onClick={deleteProduct}
                style={{
                  float: 'right',
                  cursor: 'pointer',
                  color: 'red',
                  marginTop: '5px',
                }}
              />
            </Tooltip>
          )} */}
        </DialogTitle>
        <DialogContent style={{ overflowX: 'hidden' }}>
          <AppBar
            position="static"
            color="default"
            variant="scrollable"
            scrollButtons="auto"
            style={{ flex: 1, marginRight: 20 }}
          >
            <Tabs
              value={tab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label="Product Information"
                style={{ fontWeight: 'bold' }}
                icon={<ListAltIcon />}
              />
              <Tab
                label="Print Areas"
                style={{ fontWeight: 'bold' }}
                icon={<AmpStoriesIcon />}
              />
              <Tab
                label="Product Additional Images"
                style={{ fontWeight: 'bold' }}
                icon={<PhotoIcon />}
              />
              <Tab
                label="Decorating Techniques"
                style={{ fontWeight: 'bold' }}
                icon={<StyleIcon />}
              />

              <Tab
                label="Product Sizes"
                style={{ fontWeight: 'bold' }}
                icon={<HeightIcon />}
              />
              <Tab
                label="Product Colors"
                style={{ fontWeight: 'bold' }}
                icon={<ColorLensIcon />}
              />
              <Tab
                label="Print Providers"
                style={{ fontWeight: 'bold' }}
                icon={<LocationCityIcon />}
              />
              <Tab
                label="Product Artwork Settings"
                style={{ fontWeight: 'bold' }}
                icon={<SettingsApplicationsIcon />}
              />
              <Tab
                label="Product Designer Settings"
                style={{ fontWeight: 'bold' }}
                icon={<SettingsIcon />}
              />

              {(!!isAu || !!isEu) && (
                <Tab
                  label="Product SKU"
                  style={{ fontWeight: 'bold' }}
                  icon={<SettingsIcon />}
                />
              )}
            </Tabs>
          </AppBar>

          <TabPanel value={tab} index={0}>
            <EditProductInformation
              categories={categories}
              styleTags={styleTags}
              product={product}
              brandsTags={brandsTags}
              promosTags={promosTags}
              updateProductInformation={updateProductInformation}
            />
          </TabPanel>

          {productId && (
            <React.Fragment>
              <TabPanel value={tab} index={1}>
                <EditPrintAreas
                  product={product}
                  updatePrintArea={updatePrintArea}
                />
              </TabPanel>

              <TabPanel value={tab} index={2}>
                <EditProductAdditionalImages
                  product={product}
                  addAdditionalImages={addAdditionalImages}
                />
              </TabPanel>

              <TabPanel value={tab} index={3}>
                <EditDtgPlus
                  product={product}
                  editDTGPlusInformation={editDTGPlusInformation}
                />
              </TabPanel>
              <TabPanel value={tab} index={4}>
                <EditProductSizes
                  product={product}
                  updateProductSizes={updateProductSizes}
                />
              </TabPanel>

              <TabPanel value={tab} index={5}>
                <EditColorInformation
                  product={product}
                  editColorsInformation={editColorsInformation}
                />
              </TabPanel>

              <TabPanel value={tab} index={6}>
                <EditPrintProviderInformation
                  product={product}
                  updateProductPrintProviders={updateProductPrintProviders}
                />
              </TabPanel>

              <TabPanel value={tab} index={7}>
                <EditProductArtwork
                  product={product}
                  editProductArtworkSettings={editProductArtworkSettings}
                />
              </TabPanel>

              <TabPanel value={tab} index={8}>
                <EditProductDesignerSettings
                  product={product}
                  editDesignerSettings={editDesignerSettings}
                  updatePrintArea={updatePrintArea}
                  editAdditionalTechniquesArtSettings={
                    editAdditionalTechniquesArtSettings
                  }
                />
              </TabPanel>

              {(!!isAu || !!isEu) && (
                <TabPanel value={tab} index={9}>
                  <EditProductSKU
                    product={product}
                    editSKUInformation={editSKUInformation}
                  />
                </TabPanel>
              )}
            </React.Fragment>
          )}
        </DialogContent>
      </Container>
    </Dialog>
  );
};

export default EditProductDialog;
